import { render } from "./StaffPdfStickers.vue?vue&type=template&id=7ef630e6&scoped=true"
import script from "./StaffPdfStickers.vue?vue&type=script&lang=js"
export * from "./StaffPdfStickers.vue?vue&type=script&lang=js"

import "./StaffPdfStickers.vue?vue&type=style&index=0&id=7ef630e6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef630e6"]])

export default __exports__